import { Content } from '@prismicio/client';

import { RichText } from '@preventx/prismic-services';
import { List, ListItem, UnorderedListStyle } from '@preventx/oxygen';

// Services
import { applicationEnv } from '@/services/env/shared';

type WithUnorderedListProps = {
  sliceId: string;
  slice: Content.RegionSliceWithUnorderedList;
};

export const WithUnorderedList = ({
  slice,
  sliceId,
}: WithUnorderedListProps) => {
  const { primary } = slice;
  const { list_type, first_layer, secondary_layer } = primary;

  const listType = {
    Default: undefined,
    'List Style - Disc': 'list-style-type-disc' satisfies UnorderedListStyle,
    'List Style - None': 'list-style-type-none' satisfies UnorderedListStyle,
    'List Style - Square':
      'list-style-type-square' satisfies UnorderedListStyle,
    'List Style - Circle':
      'list-style-type-circle' satisfies UnorderedListStyle,
  }[list_type] as UnorderedListStyle;

  const { WebsiteUrl } = applicationEnv();

  return (
    <List component="ul" style={listType}>
      {first_layer.map((layer, index) => {
        const secondLayer = secondary_layer.filter(
          (secondLayer) =>
            secondLayer.layer_one_group_id === layer.layer_one_group_id,
        );

        return (
          <ListItem key={`ul-layer-one-${sliceId}-${index + 1}`}>
            <RichText
              variant="default"
              content={layer.content}
              websiteUrl={WebsiteUrl}
            />

            {secondLayer.length > 0 && (
              <List component="ul" style={listType}>
                {secondLayer.map((element) => (
                  <ListItem key={`ul-layer-two-${sliceId}-${index + 1}`}>
                    <RichText
                      variant="default"
                      websiteUrl={WebsiteUrl}
                      content={element.content}
                    />
                  </ListItem>
                ))}
              </List>
            )}
          </ListItem>
        );
      })}
    </List>
  );
};
